import { enqueueSnackbar } from '@mint-lib/notifications';

type NotificationArgs = {
  title?: string;
  subTitle?: string;
};

type NotificationVariants = 'info' | 'success' | 'error';

const useSimpleNotification = () => {
  const showNotification = (
    { title = '', subTitle = '' }: NotificationArgs,
    variant: NotificationVariants,
  ) => {
    const textLayout = subTitle ? 'multiline' : 'inline';

    return enqueueSnackbar({
      variant,
      title,
      subTitle,
      textLayout,
      removable: true,
    });
  };

  const showWarningNotification = (args: NotificationArgs) =>
    showNotification(args, 'info');

  const showSuccessNotification = (args: NotificationArgs) =>
    showNotification(args, 'success');

  const showErrorNotification = (args: NotificationArgs) =>
    showNotification(args, 'error');

  return {
    showWarningNotification,
    showSuccessNotification,
    showErrorNotification,
  };
};

export default useSimpleNotification;
